import { put, select } from 'redux-saga/effects';
import { IState } from '.';
import { IEntityWithMessages } from '../services/HttpService';
import { IApiExecuteRespone } from './apiInterfaces';
import { isUser } from './auth';
import { uiActionCreators } from './ui';

const defValidation = 'There was a problem validating this action.  Please fix the following problems and retry.';
const defError = 'There was a problem performing this action.  Please retry, if the problem persists contact IT.';

export function* processMessages(
  response: IEntityWithMessages<any>,
  validationText: string = defValidation,
  errorText: string = defError
) {
  if (response.messages.length > 0) {
    yield put(
      uiActionCreators.showMessageDialog({
        messages: response.messages,
        title: validationText
      })
    );
  }

  if (response.exception) {
    yield put(
      uiActionCreators.showMessageDialog({
        exception: response.exception,
        messages: [
          `An exception occured trying to perform this action.
          Please retry.  If this problem persists, contact IT`
        ],
        title: 'An error occured!'
      })
    );
  }
}

export function* showFailedRequestDialog(response: IApiExecuteRespone<any>) {
  const itUser: boolean = yield select((state: IState) => isUser(state, 'it'));

  let messages: string[] = [
    `An exception occured trying to perform this action.
    Please retry.  If this problem persists, contact IT`
  ];

  if (itUser && response.exception) {
    messages = [...messages, `Exception Message: ${response.exception.message}`];
  }

  yield put(
    uiActionCreators.showMessageDialog({
      exception: response.exception,
      messages,
      title: 'An error occured!'
    })
  );
}
